<template>
  <section id="home">
    <v-parallax src="/static/backgrounds/bg1.jpg" height="850">
      <v-layout
        column
        align-center
        justify-center
        class="white--text"
      >
        <transition name="slide-up" appear>
          <div>
            <h1 :class="'white--text mb-2 text-xs-center ' + displayTitle">Carano Diseño Web</h1>
            <h2 class="white--text mb-2 text-xs-center headline">Soluciones Web &amp; Marketing Digital</h2>
          </div>
        </transition>
        <v-btn
          :class="hideBtn + ' deep-purple darken-1 mt-5'"
          round
          dark
          large
          @click.stop="dialog=true"
        >
          Contactanos
        </v-btn>
        <app-contact-dialog :dialog="dialog" @dialog="dialog = $event"></app-contact-dialog>
      </v-layout>
    </v-parallax>
  </section>
</template>

<script>
import ContactDialog from '../addons/ContactDialog.vue'
export default {
  data () {
    return {
      displayTitle: 'display-4',
      hideBtn: 'scale-hide-btn',
      dialog: false
    }
  },
  components: {
    'app-contact-dialog': ContactDialog,
  },
  mounted () {
    window.onload = function() {
      setTimeout(() => {
        document.querySelector('.scale-hide-btn').classList.add('scale-show-btn');
        document.querySelector('.scale-hide-btn').classList.remove('scale-hide-btn');
      }, 2000);
    };
    if(window.innerWidth < 1024) {
      this.displayTitle = 'display-3'
    }
  },
  methods: {
  }
}
</script>

<style scoped>

.scale-hide-btn {
  transform: scale(0);
}

.scale-show-btn {
  transform: scale(1);
  transition: transform 1s ease-in-out;
}

.slide-up-enter-active {
  animation: slide-up 2s forwards;
}

@keyframes slide-up {
  from { transform: translateY(500px)}
  to {transform: translateY(0)}
}

</style>




// WEBPACK FOOTER //
// src/components/sections/Home.vue